import { render, staticRenderFns } from "./viewArticles.vue?vue&type=template&id=9fc2bff0&scoped=true&"
import script from "./viewArticles.vue?vue&type=script&lang=js&"
export * from "./viewArticles.vue?vue&type=script&lang=js&"
import style0 from "./viewArticles.vue?vue&type=style&index=0&id=9fc2bff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc2bff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fc2bff0')) {
      api.createRecord('9fc2bff0', component.options)
    } else {
      api.reload('9fc2bff0', component.options)
    }
    module.hot.accept("./viewArticles.vue?vue&type=template&id=9fc2bff0&scoped=true&", function () {
      api.rerender('9fc2bff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/recovery/components/viewArticles.vue"
export default component.exports